/* eslint-disable import/no-unused-modules */
import { useNumerousReleases } from "@/api";
import { useEffect, useState } from "react";
import { useLocalStorage } from "usehooks-ts";
import { v1Release } from "../assets/v1Release";

type PollingStatus = "Pending" | "Active" | "Stopped";

const FIVE_MINUTES_IN_MILLIS = 300_000; // 5 minutes

export function useClientReleaseCheck() {
  const [pollingStatus, setPollingStatus] = useState<PollingStatus>("Pending");
  const [displayReleaseNotes, setDisplayReleaseNotes] = useState(false);
  const [newReleaseAvailable, setNewReleaseAvailable] = useState(false);
  const [prevVersionId, setPrevVersionId] = useState<string | undefined>(
    undefined
  );
  const [clientVersionId, setClientVersionId] = useLocalStorage<
    string | undefined
  >("clientVersionId", undefined);
  const [, setClientVersion] = useLocalStorage<string | undefined>(
    "clientVersion",
    undefined
  );
  const { data, error, startPolling, stopPolling } = useNumerousReleases();

  if (error) console.error(error);

  useEffect(() => {
    // First fetch checks if release notes should be displayed and sets current client version
    if (pollingStatus !== "Pending") return;
    if (!data) return;

    startPolling(FIVE_MINUTES_IN_MILLIS);
    setPollingStatus("Active");

    const latestRelease = data.numerousReleases[0];
    if (!latestRelease && !clientVersionId) {
      setDisplayReleaseNotes(true);
      setClientVersionId(v1Release.id);
      setClientVersion(v1Release.name);
      return;
    }
    if (!latestRelease || latestRelease.id === clientVersionId) return;

    setPrevVersionId(clientVersionId);
    setDisplayReleaseNotes(true);
    setClientVersionId(latestRelease.id);
    setClientVersion(latestRelease.name);
  }, [
    clientVersionId,
    data,
    pollingStatus,
    setClientVersion,
    setClientVersionId,
    startPolling
  ]);

  useEffect(() => {
    if (pollingStatus !== "Active") return;

    const latestRelease = data?.numerousReleases[0];
    if (
      !latestRelease ||
      (clientVersionId && latestRelease.id === clientVersionId)
    )
      return;

    setNewReleaseAvailable(true);
    stopPolling();
    setPollingStatus("Stopped");
  }, [clientVersionId, data, pollingStatus, stopPolling]);

  return {
    displayReleaseNotes,
    prevVersionId,
    newReleaseAvailable
  };
}
